const DefaultCheckoutButtonHeight = 36;

export default DefaultCheckoutButtonHeight;
